import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import MemoOut from "../../../containers/modules/accounting/memo-out";

export default function MemoOutRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="memo-out"
      index
      element={
        <AccessControl
          name={"Memo Out Create"}
          auth={authUser}
          component={() => <MemoOut />}
        />
      }
    />
  );
}
